module.exports = __webpack_public_path__ + "img/valuationResultDV.c927d1d1.png";